/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { UtilityService } from '../../core/services/utility_functions/utility_functions.service';
import { ReplaySubject } from 'rxjs';
import { countries } from './contact-info.interface';

@Injectable({
    providedIn: 'root'
})
export class ContactInfoService {
    address: ReplaySubject<any> = new ReplaySubject<any>(1);
    countries: any[] = countries;

    constructor(
        private utilityService: UtilityService) { }

    getContactInfoAddressModel(formValue: any): any {
        if (!formValue) {
            return null;
        }
        const addressModel: any = {
            city: formValue.city,
            country: formValue.country?.label ?? formValue.country ?? '',
            email: formValue.email,
            first_name: formValue.firstName,
            landmark: formValue.landmark,
            last_name: formValue.lastName,
            phone_number: formValue.phone,
            state: formValue.state,
            street: formValue.street,
            zip_code: formValue.zipcode
        };
        if (!this.utilityService.isEmptyOrUndefined(formValue.latitude) && !this.utilityService.isEmptyOrUndefined(formValue.longitude)) {
            addressModel['geo_cordinates'] = [formValue.latitude, formValue.longitude];
        }
        return addressModel;
    }

    populateAddressFields(data: any): any {
      return {
        street: data?.['street'] || '',
        city: data?.['city'] || '',
        country: this.countries.find((cnt: any)=>cnt.label === data?.country) || null,
        firstName: data?.['first_name'] || '',
        lastName: data?.['last_name'] || '',
        phone: data?.['phone_number'] || '',
        state: data?.['state'] || '',
        email: data?.['email'] || '',
        latitude: data?.['geo_cordinates']?.[0] || 0,
        longitude: data?.['geo_cordinates']?.[1] || 0,
        landmark: data?.['landmark'] || '',
        zipcode: data?.['zip_code'] || ''
      };
    }
}
